function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n        .st0{fill:#f2f2f2}.st1{fill-rule:evenodd;clip-rule:evenodd;}.st2{fill:#f2f2f2}.st3{fill:#cccccc}\n    ");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M102,115.4l3.4,0l0.1,9.9l9.3-9.9l4.2,0l-8.1,8.5l8.6,11.1l-4.2,0l-6.8-8.8l-3,3.2l0,5.7l-3.4,0L102,115.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M129.7,115.2l14.6-0.1l0,3.1l-11.1,0.1l0,5.1l9.8-0.1l0,3.1l-9.8,0.1l0,5.3l11.2-0.1l0,3.1l-14.7,0.1 L129.7,115.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M155.7,115l14.6-0.1l0,3.1l-11.1,0.1l0,5.1l9.8-0.1l0,3.1l-9.8,0.1l0,5.3l11.2-0.1l0,3.1l-14.7,0.1L155.7,115z "
}), React.createElement("path", {
  className: "st0",
  d: "M181.8,114.8l7.7-0.1c4.6,0,7.5,2.6,7.5,6.5l0,0.1c0,4.4-3.5,6.7-7.8,6.8l-3.9,0l0,6.3l-3.5,0L181.8,114.8z  M189.4,125c2.6,0,4.2-1.5,4.2-3.5v-0.1c0-2.3-1.7-3.5-4.3-3.5l-4,0l0.1,7.1L189.4,125z"
}), React.createElement("path", {
  className: "st0",
  d: "M208,114.6l3.4,0l0.1,19.6l-3.5,0L208,114.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M224,114.5l14.6-0.1l0,3.1l-11.2,0.1l0,5.4l9.9-0.1l0,3.1l-9.9,0.1l0.1,8l-3.4,0L224,114.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M255.6,126.1l-7.9-11.8l4.1,0l5.6,8.7l5.5-8.7l4,0l-7.7,11.9l0.1,7.8l-3.5,0L255.6,126.1z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st1 st2",
  points: "73,103.1 73,111.6 64.1,116.7 55.2,121.8 55.2,139.5 64.1,146.6 64.1,126.9 64.1,125.9 81.8,115.7  81.8,103.1 73,103.1  "
}), React.createElement("polygon", {
  className: "st1 st3",
  points: "64.1,113.7 64.1,103.1 55.2,103.1 55.2,118.9 64.1,113.7  "
}), React.createElement("polygon", {
  className: "st1 st3",
  points: "66.7,127.4 73,131 73,146.9 81.8,139.5 81.8,125.9 75.5,122.3 66.7,127.4  "
}));

var SvgLogoNameLight = function SvgLogoNameLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330 250",
    style: {
      enableBackground: "new 0 0 330 250"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoNameLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoNameLight.856eb444.svg";
export { ForwardRef as ReactComponent };